module.exports = __webpack_public_path__ + "img/UNUCR_logo.036a1eab.png";